import store from './../../store'

const setup = (sidebar) => {
  const isSettingsApp = store.getters.getAppCurrent.app_id === null
  if (isSettingsApp) {
    store.dispatch('setSidebar', sidebar)
  } else {
    store.dispatch('setSidebar', mapSidebar(sidebar))
  }
}

const active = (opts) => {
  store.dispatch('activeSidebar', opts)
}

const update = (sidebar, sidebarAtIdx, submenus, opts) => {
  const temp = JSON.stringify(sidebar)
  const newSidebar = JSON.parse(temp)
  for (const i in submenus) {
    newSidebar[sidebarAtIdx].submenus.push(submenus[i])
  }
  store.dispatch('setSidebar', newSidebar)
  if (opts) {
    active(opts)
  }
}

const init = (sidebar, opts) => {
  setup(sidebar)
  if (opts) {
    active(opts)
  }
}

/**
 * utils functions
 **/
const viewModuleAble = (moduleId, permission) => {
  return permission.modules.reduce((acc, cur) => {
    if (cur.module_id === moduleId && !acc) {
      const hasSubModules = cur.sub_modules && !!cur.sub_modules.length
      if (hasSubModules) {
        acc = cur.sub_modules.reduce((_acc, _cur) => {
          if (!_acc) {
            const hasSomeAction = Object.keys(_cur.action).some((key) => _cur.action[key] === true)
            _acc = hasSomeAction
          }
          return _acc
        }, false)
      } else {
        const hasSomeAction = Object.keys(cur.action).some((key) => cur.action[key] === true)
        acc = hasSomeAction
      }
    }
    return acc
  }, false)
}

const viewSubModuleAble = (moduleId, itemSubModule, permission) => {
  const subModuleId = itemSubModule.subModuleId
  if (!subModuleId) {
    const permissionModule = permission.modules.find((item) => item.module_id === moduleId)
    const action = permissionModule ? permissionModule.action : null
    if (action == null) {
      return true
    }
    if (['sidebar.all'].includes(itemSubModule.name)) {
      return action.view
    } else if (['sidebar.create'].includes(itemSubModule.name)) {
      return action.create
    } else {
      return true
    }
  } else {
    return permission.modules.reduce((acc, cur) => {
      if (cur.module_id === moduleId && !acc) {
        const hasSubModules = cur.sub_modules && !!cur.sub_modules.length
        if (hasSubModules) {
          acc = cur.sub_modules.reduce((_acc, _cur) => {
            if (_cur.sub_module_id === subModuleId && !_acc) {
              const hasSomeAction = Object.keys(_cur.action).some((key) => _cur.action[key] === true)
              _acc = hasSomeAction
            }
            return _acc
          }, false)
        }
      }
      return acc
    }, false)
  }
}

const mapModule = (itemModule, permission) => {
  return {
    ...itemModule,
    show: viewModuleAble(itemModule.moduleId, permission),
  }
}

const mapSubMenus = (moduleId, submenus, permission) => {
  return submenus.map((itemSubModule) => {
    return {
      ...itemSubModule,
      show: viewSubModuleAble(moduleId, itemSubModule, permission),
    }
  })
}

const mapSidebar = (sidebar) => {
  const appId = store.getters.getAppCurrent.app_id
  const permissions = store.getters.getAuth.user_info.permissions
  const permission = permissions.find((item) => item.app_id === appId)
  return sidebar.map((itemModule) => {
    const module = mapModule(itemModule, permission)
    if (module.submenus) {
      module.submenus = mapSubMenus(itemModule.moduleId, module.submenus, permission)
    }
    return module
  })
}

export default {
  setup,
  active,
  update,
  init,
  mapSidebar,
  viewModuleAble,
  viewSubModuleAble,
}



// WEBPACK FOOTER //
// ./src/components/apps/sidebarModule.js